// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"TasksDropdown-styles-module--dropdown--143ga"};